import { appClientsService, individualsService } from '@aslanpay/portal-common-lib';
import { useQuery } from '@tanstack/react-query';

export const fetchCognitoAppClientsQuery = (companyId?: string, enabled = true) => ({
  queryKey: ['fetchCognitoAppClients', companyId],
  queryFn: async () => {
    const appClients = await appClientsService.fetchAppClients({ companyIds: [companyId || ''] });

    const NIL_UUID = '00000000-0000-0000-0000-000000000000';
    const individualIds = Array.from(
      new Set(
        appClients
          .map((client) => client.createdBy)
          .filter((id) => id !== undefined && id !== NIL_UUID)
      )
    );

    if (individualIds.length === 0) {
      return appClients;
    }

    const individuals = await individualsService.fetchIndividuals({
      ids: individualIds,
      page: 0,
      size: 999999,
    });

    const appClientsList = appClients.map((client) => {
      const createdByIndividual = individuals.list.find((ind) => ind.id === client.createdBy);

      const createdByName = (() => {
        if (createdByIndividual)
          return `${createdByIndividual.firstName} ${createdByIndividual.lastName}`;
        if (client.createdBy === NIL_UUID) return 'System';
        return undefined;
      })();

      return { ...client, createdByName };
    });

    return appClientsList;
  },
  enabled: !!companyId && enabled,
});

const useFetchCognitoAppClients = (companyId?: string, enabled = true) => {
  return useQuery(fetchCognitoAppClientsQuery(companyId, enabled));
};

export default useFetchCognitoAppClients;
